import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "22px",
  height: "22px",
  viewBox: "0 0 22 22",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<title>8E2E38B9-45EE-4FB3-B4D6-E63C3923365E</title><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"00_MovingLayers_UI_Design-System\" transform=\"translate(-698.000000, -4004.000000)\"><g id=\"Icon/Progress/0-Copy-2\" transform=\"translate(698.000000, 4004.000000)\"><g id=\"Group\" transform=\"translate(1.000000, 1.000000)\"><circle id=\"Oval\" stroke=\"var(--primary)\" stroke-width=\"2\" cx=\"10\" cy=\"10\" r=\"10\"></circle><path d=\"M10,17 C13.8659932,17 17,13.8659932 17,10 C17,6.13400675 13.8659932,3 10,3 C10,3 10,17 10,17 Z\" id=\"Oval-Copy\" fill=\"var(--primary)\"></path></g></g></g></g>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}